import React, {useEffect, useState} from 'react';
import Header from "../layout/Header";
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch} from "react-redux";
import {AGModalId, AGModalOpen} from "../../store/slices/main.slice";
import {useTranslation} from "react-i18next";
import {apiService} from "../../services/api.service";
import {parseText} from "../../utils/transaltions.utils";
import QRScanner from "../QRScanner";

const Item = ({ data, divider }: any) => {
    const { i18n }: any = useTranslation('translation');
    const dispatch: any = useDispatch();

    const openModal = (id: any) => {
        dispatch(AGModalOpen(true))
        dispatch(AGModalId(id));
    }

    return (
        <div className="w-full sm:w-1/3 lg:w-1/3 xl:w-1/4 px-[20px] pb-[30px] md:pb-[70px]">
            <div className="relative flex flex-col items-center justify-center w-full sm:w-[75%]">
                <div onClick={() => openModal(data.id)} className="absolute inset-0 flex items-center justify-center cursor-pointer z-[2]">
                    <img src={`/images/play-icon.png`} alt="Play icon" className="h-[20px]"/>
                </div>
                <img src={`${data.thumb}`} alt="Percorso image" className="h-auto"/>
                {divider && <div className="flex absolute inset-0 flex-col items-center justify-center"><img src={`/images/gndm_shape_arrow.png`} alt="Arrow image" className="h-[25px] w-auto ml-[150%]"/></div>}
            </div>
            <h3 className="text-black text-sm lg:text-base font-bold leading-[1.3] pt-[15px]">{parseText(data.title, i18n)}</h3>
            {divider && <div className="flex sm:hidden flex-col items-center justify-center"><img src={`/images/gndm_shape_arrow.png`} alt="Arrow image" className="h-[30px] w-auto mt-[30px] rotate-[90deg]"/></div>}
        </div>
    );
};

const SinglePercorso = () => {
    const { t, i18n }: any = useTranslation('translation');
    const navigate = useNavigate();
    const [data, setData] = useState<any>(null)
    const [isLoading, setIsLoading] = useState(true)
    const { id } = useParams();

    useEffect(() => {
        apiService.getSinglePercorso(id)
            .then((res) => {
                setData(res.data)

                if(res.status === 200) {
                    setIsLoading(false)
                }
            })
    }, []);

    const [scanning, setScanning] = useState(false);

    // QR Code scanning
    const handleScanResult = (data: string) => {
        if (data) {
            window.location.href = data;
        }
    };

    const startScanner = () => {
        setScanning(true);
    };

    const stopScanner = () => {
        setScanning(false);
    };

    if(isLoading) {
        return null
    }

    if(data) {
        return (
            <>
                {scanning && <QRScanner onScan={handleScanResult} onClose={stopScanner}/>}
                <div className="relative flex flex-col items-start h-screen-dynamic w-screen overflow-hidden overflow-x-hidden">
                    <div className="w-full h-max z-[2] bg-[#e4dbd6]">
                        <Header version="dark"/>
                    </div>
                <div className="w-full h-full overflow-y-auto overflow-x-hidden">
                    <div className="flex flex-col sm:flex-row gap-[100px] w-full lg:mt-[60px] sm:mt-[30px] mt-[60px] px-[20px] sm:px-[30px] lg:px-[100px] overflow-y-auto overflow-hidden h-max">
                        <section className="w-full sm:w-1/2 h-max">
                            <div className="flex flex-row items-start gap-[20px] mb-[30px] lg:mb-[50px] sm:mb-[20px]">
                                <img onClick={() => navigate('/percorsi')} src={`/images/arrow-back-black.png`} alt="Back icon" className="lg:h-[30px] h-[20px] w-auto mt-[5px] md:mt-[12px] cursor-pointer"/>
                                <div>
                                    <h2 className="text-black md:text-[28px] lg:text-[40px] text-[22px] font-untitledSans">{parseText(data.title, i18n)}</h2>
                                    <h3 className="text-[#ec651f] text-xs md:text-base lg:text-md">{parseText(data.content, i18n)}</h3>
                                </div>
                            </div>
                            <p className="text-black text-xs lg:text-sm text-justify">
                                {parseText(data.text, i18n)}
                            </p>
                        </section>
                        <section className="w-full sm:w-1/2 flex flex-col items-center lg:items-center sm:items-start sm:mt-[60px] justify-center sm:justify-start lg:justify-center mt-[-60px] lg:mt-0">
                            <img src={parseText(data.floorImage, i18n)} alt="Planimetria" className="h-auto w-full lg:w-[55%]"/>
                        </section>
                    </div>
                    <div className="hidden sm:flex flex-wrap justify-start w-full mt-[150px] sm:mt-[50px] lg:px-[80px] pb-[100px] lg:pb-0">
                        {data.agData.map((item: any, _i: number) => {
                            return <Item key={`item-${_i}`} data={item} divider={_i < data.agData.length - 1}/>
                        })}
                    </div>
                    <div className="flex sm:hidden flex-col items-center justify-center w-full mt-[100px] md:mt-[100px] px-[30px] lg:px-[80px] pb-[180px] md:pb-0">
                        {data.agData.map((item: any, _i: number) => {
                            return <Item key={`item-${_i}`} data={item} divider={_i < data.agData.length - 1}/>
                        })}
                    </div>
                </div>
                <div className="flex sm:hidden fixed left-0 bottom-0 z-[900] w-full bg-black/95 h-[100px] flex-row items-center justify-center px-[20px]">
                    {!scanning && <div onClick={startScanner} className="flex flex-col items-center gap-[7px] cursor-pointer">
                        <img src={`/images/icona-inquadra.png`} alt="Inquadra-icona" className="h-[30px]"/>
                        <span className="text-white text-xs text-center font-untitledSans">{t('ag.global_inquadra')}</span>
                    </div>}
                </div>
                <div className="hidden sm:flex lg:hidden fixed left-0 bottom-0 z-[900] w-full bg-black/95 h-[60px] flex-row items-center justify-center px-[20px]">
                    {!scanning && <div onClick={startScanner} className="flex flex-row items-center gap-[10px] cursor-pointer">
                        <img src={`/images/icona-inquadra.png`} alt="Inquadra-icona" className="h-[30px]"/>
                        <span className="text-white text-xs text-center font-untitledSans">{t('ag.global_inquadra')}</span>
                    </div>}
                </div>
            </div>
            </>
        )
    }

    return null
};

export default SinglePercorso;
